export default __webpack_public_path__ + "static/media/1706aae9.svg";